import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
var _excluded = ["inline", "token", "tokenOffset", "spacing", "align", "reverse", "stackBelow", "children"];
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.includes.js";
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, spacing } from 'styles/globals';
import { getSpacing, getPropNamesFromPropDefinition, getPropFilter } from 'utils/ui';
import { marginProps, marginPropsDef, sizeProps, sizePropsDef } from 'styles/styleProps';
export var alignMap = {
  top: 'flex-start',
  center: 'center',
  bottom: 'flex-end'
};
var flagPropNames = ['align', 'spacing', 'reverse', 'stackBelow', 'offset'];
var shouldForwardProp = getPropFilter([].concat(_toConsumableArray(getPropNamesFromPropDefinition([].concat(_toConsumableArray(marginPropsDef), _toConsumableArray(sizePropsDef)))), flagPropNames));
var Wrapper = styled.div.withConfig({
  shouldForwardProp: shouldForwardProp
}).withConfig({
  displayName: "Flag__Wrapper",
  componentId: "sc-3oh54b-0"
})(["display:flex;align-items:", ";", " ", " ", " ", ""], function (p) {
  return p.align && alignMap[p.align];
}, sizeProps, marginProps, function (p) {
  return p.reverse && css(["flex-direction:row-reverse;"]);
}, function (p) {
  return p.stackBelow && css(["@media (max-width:", "){flex-direction:column;align-items:center;text-align:center;}"], breakpoints[p.stackBelow]);
});
var Token = styled.div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !flagPropNames.includes(prop);
  }
}).withConfig({
  displayName: "Flag__Token",
  componentId: "sc-3oh54b-1"
})(["flex:none;", " ", " ", ";"], function (p) {
  return p.reverse ? css(["margin-left:", ";"], function (p) {
    return spacing[p.spacing];
  }) : css(["margin-right:", ";"], function (p) {
    return spacing[p.spacing];
  });
}, function (p) {
  return p.offset && css(["margin-top:", ";"], getSpacing(p.offset, p.theme));
}, function (p) {
  return p.stackBelow && "\n\t\t\t\t@media (max-width: ".concat(breakpoints[p.stackBelow], ") {\n\t\t\t\t\tmargin: 0;\n\t\t\t\t\tmargin-bottom: ").concat(spacing[p.spacing], "\n\t\t\t\t}\n\t\t\t");
});
var Content = styled.div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !flagPropNames.includes(prop);
  }
}).withConfig({
  displayName: "Flag__Content",
  componentId: "sc-3oh54b-2"
})(["flex:1 1 auto;min-width:0;width:100%;", ""], function (p) {
  return p.stackBelow && css(["@media (max-width:", "){width:auto;}"], breakpoints[p.stackBelow]);
});
var Flag = function Flag(_ref) {
  var inline = _ref.inline,
    token = _ref.token,
    tokenOffset = _ref.tokenOffset,
    _ref$spacing = _ref.spacing,
    spacing = _ref$spacing === void 0 ? 's' : _ref$spacing,
    _ref$align = _ref.align,
    align = _ref$align === void 0 ? 'center' : _ref$align,
    reverse = _ref.reverse,
    stackBelow = _ref.stackBelow,
    children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var as = inline ? 'span' : undefined;
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    as: as,
    align: align,
    stackBelow: stackBelow,
    reverse: reverse
  }, otherProps), token && /*#__PURE__*/React.createElement(Token, {
    as: as,
    spacing: spacing,
    offset: tokenOffset,
    stackBelow: stackBelow,
    reverse: reverse
  }, token), /*#__PURE__*/React.createElement(Content, {
    as: as,
    stackBelow: stackBelow
  }, children));
};
export default Flag;